import { usePage } from '@inertiajs/react'
import DepartmentForm from './DepartmentForm'
import { t } from '@/shared/lib/i18n'
import { departmentPath, departmentsPath, organizationPath } from '@/shared/lib/routes'
import { useBreadcrumbs } from '@/shared/lib/breadcrumbs-context'
import type { WebDepartmentForm } from '@/shared/types/web'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface SiteOption {
  value: number
  label: string
}

interface Props {
  sites: SiteOption[]
  department: WebDepartmentForm
  parentDaySchedule: WeekdaySchedule
  [key: string]: unknown
}

const EditDepartmentPage = () => {
  const { sites, department, parentDaySchedule } = usePage<Props>().props

  useBreadcrumbs([
    { label: t('nav.administration'), href: organizationPath() },
    { label: t('nav.departmentsAndUnits'), href: departmentsPath() },
    { label: t('nav.departments'), href: departmentsPath() },
    { label: t('organization.departments.editTitle') },
  ])

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">
        {t('organization.departments.editTitle')}: {department.name}
      </h1>
      <DepartmentForm
        sites={sites}
        initialData={department}
        submitUrl={departmentPath(department.id)}
        submitMethod="patch"
        parentDaySchedule={parentDaySchedule}
      />
    </div>
  )
}

export default EditDepartmentPage
